import tippy from 'tippy.js';

const tooltipConfig = {
  allowHTML: true,
  interactive: true,
  interactiveBorder: 30,
  interactiveDebounce: 75,
  offset: [0, 10],
};

tippy('[data-tippy-content]', { ...tooltipConfig });

export default tooltipConfig;
